/* ============================================================================
FILE: po-katupirsia9-saison-posoennoiale-texts-fr-en-es-20260328.js
MODE: protected trilingual with FR / EN / ES buttons + canonical lexicon preserved
API:  window.PoKatupirsia9SaisonPosoennoialeTextsFR_EN_ES_20260328
ROOT: .po-axis-section[data-po-axis='saison_posoennoiale']
ROLE:
  - Langue pilotée par localStorage : po_lex_lang + compat goody_gp_lang
  - Injection trilingue FR / EN / ES dans les slots
  - Protection fine du lexique canonique FR (avec variantes œ/oe, apostrophes)
  - Couche audio locale par bloc + lecture générale, greffée sans casser la logique existante
  - Multi-instances OK
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_SAISON_POSOENNOIALE_TEXTS_20260328__) return;
  window.__PO_KATUPIRSIA9_SAISON_POSOENNOIALE_TEXTS_20260328__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='saison_posoennoiale']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/SAison_posoennoiale_conceptuel.png?v=1773269901";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/SAison_posoennoiale_fonctionnel.png?v=1773269901";
  var PAGE_URL     = "https://goodyart.store/pages/saison-posoennoiale";

  var CANON_TERMS_FALLBACK = [
    "Saison posœnnoïale",
    "Année posœnnoïale",
    "Année posœnnoïale (AP)",
    "AP",
    "Mois posœnnoïal",
    "Addition synchrêtique",
    "Épagomènes",
    "Épagomène",
    "Souffle d’Or",
    "Katûpirsia",
    "Àṣẹxel’Or",
    "Humanus",
    "Numéris",
    "Air",
    "Feu",
    "Eau",
    "Terre",
    "Posœnnoïa",
    "Posœnnoïal",
    "Posœnnoïsme",
    "Idéogramme conceptuel",
    "Idéogramme fonctionnel"
  ];

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang3){
    var lang = normLang(lang3);
    try{ localStorage.setItem(STORAGE_KEY, lang); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, lang); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", lang.toLowerCase()); }catch(__e){}
    return lang;
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "FR";
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "FR";
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event("po:locale-changed")); }
    catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var key = clampStr(v).trim();
    if (!key || seen[key]) return;
    seen[key] = true;
    arr.push(key);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term).trim();
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);
    uniqPush(out, t.replace(/É/g, "E").replace(/é/g, "e"), seen);

    if (t.indexOf("/") > -1){
      t.split("/").forEach(function(part){
        buildVariants(part).forEach(function(v){ uniqPush(out, v, seen); });
      });
    }

    return out;
  }

  function getRuntimeLexiqueList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE)){
        return window.PO_LEXIQUE_SIMPLIFIE.slice();
      }
    }catch(e){}
    return [];
  }

  function getCanonicalTerms(){
    var seen = Object.create(null);
    var out = [];
    CANON_TERMS_FALLBACK.forEach(function(term){ buildVariants(term).forEach(function(v){ uniqPush(out, v, seen); }); });
    getRuntimeLexiqueList().forEach(function(term){ buildVariants(term).forEach(function(v){ uniqPush(out, v, seen); }); });
    out.sort(function(a, b){ return b.length - a.length; });
    return out;
  }

  function getCanonicalRegex(){
    if (getCanonicalRegex._cache) return getCanonicalRegex._cache;
    var terms = getCanonicalTerms();
    if (!terms.length){
      getCanonicalRegex._cache = null;
      return null;
    }
    getCanonicalRegex._cache = new RegExp("(" + terms.map(escapeRegExp).join("|") + ")", "g");
    return getCanonicalRegex._cache;
  }

  function protectPlainTextSegment(text){
    var segment = clampStr(text);
    if (!segment) return "";
    var rx = getCanonicalRegex();
    if (!rx) return escapeHTML(segment);
    return escapeHTML(segment).replace(rx, function(m){
      return '<span class="notranslate" translate="no">' + m + '</span>';
    });
  }

  function protectHTML(html){
    var src = clampStr(html);
    if (!src) return "";
    var parts = src.split(/(<[^>]+>)/g);
    for (var i = 0; i < parts.length; i++){
      if (!parts[i] || /^<[^>]+>$/.test(parts[i])) continue;
      parts[i] = protectPlainTextSegment(parts[i]);
    }
    return parts.join("");
  }

  function protectTextNode(node){
    if (!node || !node.nodeValue) return;
    if (!node.parentNode) return;
    if (!node.nodeValue.trim()) return;
    if (node.parentNode.closest && node.parentNode.closest('.notranslate,[translate="no"],script,style,textarea')) return;

    var rx = getCanonicalRegex();
    if (!rx || !rx.test(node.nodeValue)) return;
    rx.lastIndex = 0;

    var text = node.nodeValue;
    var frag = document.createDocumentFragment();
    var lastIndex = 0;
    var match;

    while ((match = rx.exec(text))){
      if (match.index > lastIndex){
        frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      var span = document.createElement("span");
      span.className = "notranslate";
      span.setAttribute("translate", "no");
      span.textContent = match[0];
      frag.appendChild(span);
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length){
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    node.parentNode.replaceChild(frag, node);
  }

  function protectDOM(root){
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(protectTextNode);
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectHTML(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.innerHTML = protectHTML(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";

      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.innerHTML = protectHTML((b || {}).head || "");

      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.innerHTML = protectHTML((b || {}).text || "");

      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
  }

  var CONTENT = {
    FR: {
      title: "Saison posœnnoïale",
      title_img: CONCEPT_URL,
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Grande respiration collective, signature saisonnière et orientation des pratiques)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Regroupement de trois mois : grande respiration d’un régime. Addition synchrêtique + signature : orienter pratiques et gestes sur une tenue collective.",
      def_long: "<p>Dans <em>Katûpirsia&nbsp;9</em>, la Saison posœnnoïale est une unité du temps fondée sur le regroupement de trois mois. Elle constitue une respiration collective, plus vaste que le mois, et organise l’année en quatre grands régimes : Air, Feu, Eau et Terre.</p><p>Le corpus précise que son calcul s’appuie sur l’Addition synchrêtique des trois mois qui la composent. On additionne leurs totaux synchrêtiques, puis on réduit selon la logique interne afin d’obtenir une signature saisonnière. L’exemple donné pour la saison de l’Air est explicite : janvier + février + mars = 5986 → 28 → 10 → 1.</p><p>La Saison posœnnoïale n’est donc pas seulement un regroupement calendaire. Elle installe un régime de conscience et de pratiques où la création, la parole, le souffle et les gestes se calibrent sur une tenue commune. Dans l’architecture générale de l’Année posœnnoïale, elle correspond à l’échelle où l’orientation collective devient lisible.</p><p>Le manuscrit associe à chaque saison des rituels collectifs : l’Air appelle les chants et les cercles vocaux, le Feu les épreuves et les veillées ardentes, l’Eau les traversées et les recompositions, la Terre les plantations, constructions et gestes d’incarnation. La saison devient alors un organe respiratoire du collectif, un axe de stabilisation à grande amplitude, accordé aux cycles solaires et lunaires.</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Unité saisonnière : trois mois forment une grande respiration collective.",
        "Quatre régimes : Air, Feu, Eau et Terre structurent l’année à l’échelle large.",
        "Calcul attesté : Addition synchrêtique des trois mois puis réduction en signature saisonnière.",
        "Fonction développée : stabiliser un régime et faire converger les mois vers une tenue commune.",
        "Orientation rituelle : chaque saison appelle des pratiques collectives cohérentes avec son archétype."
      ],
      questions: [
        "Quel régime saisonnier domine ici : Air, Feu, Eau ou Terre, et quel axe de pratique appelle-t-il ?",
        "Quel réglage minimal rend la saison habitable : cadence, rituel, cadre collectif, densité ?",
        "Quel acte bref confirme la tenue du régime : chant, veillée, geste, œuvre ou plantation ?",
        "La lecture engagée relève-t-elle d’un mois isolé, ou d’une respiration collective plus vaste ?"
      ],
      example_box: "<div><strong>Ex.</strong> Une communauté qui ouvre un cycle de chants partagés, de gestes respirés et d’orientations communes au seuil de l’Air vit la logique de la Saison posœnnoïale : la tenue cesse d’être individuelle et devient collective.</div>",
      family_1: "<p><strong>Liens internes :</strong> la Saison posœnnoïale est une sous-entrée de l’AP. Elle se relie au Mois posœnnoïal qui la compose, à Numéris pour la lecture des signatures, à la triade 3–6–9, à Humanus pour les rites et collectifs, et au Souffle d’Or comme unité respirante.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> dans l’architecture de l’Année posœnnoïale, la saison fait passer du régime archétypal du mois à une orientation collective accordée aux cycles solaires et lunaires. Elle stabilise une grande respiration commune et prépare le franchissement vers les Épagomènes.</p>",
      word_blocks: [
        { head: "1) Saison", text: "Durée large, régime, orientation commune : une tenue qui dépasse l’instant et le mois pour devenir respiration collective." },
        { head: "2) Posœnnoïale", text: "Le terme inscrit la saison dans l’écologie du corpus : lecture respirée du temps, calcul synchrêtique, pratiques accordées, et tenue du collectif." },
        { head: "3) Ensemble", text: "Saison posœnnoïale nomme l’unité de trois mois lorsqu’ils deviennent régime respiratoire, signature lisible et axe de pratiques communes." }
      ],
      word_notes: [
        "Deux idéogrammes attestés : conceptuel et fonctionnel.",
        "Définition essentielle attestée : 3 mois = respiration collective.",
        "Fonction attestée : stabiliser un régime.",
        "Exemple canonique de calcul : Air = 5986 → 28 → 10 → 1."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    EN: {
      title: "Saison posœnnoïale",
      title_img: CONCEPT_URL,
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Large collective breath, seasonal signature, and orientation of practices)",
      h_def: "Operational definition",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Grouping of three months: large breath of a regime. Addition synchrêtique + signature: orient practices and gestures toward a collective hold.",
      def_long: "<p>In <em>Katûpirsia&nbsp;9</em>, Saison posœnnoïale is a unit of time founded on the grouping of three months. It constitutes a collective breath, wider than the month, and organizes the year into four major regimes: Air, Feu, Eau, and Terre.</p><p>The corpus specifies that its calculation relies on the Addition synchrêtique of the three months that compose it. Their synchretic totals are added, then reduced according to the internal logic in order to obtain a seasonal signature. The example given for the season of Air is explicit: January + February + March = 5986 → 28 → 10 → 1.</p><p>Saison posœnnoïale is therefore not merely a calendar grouping. It installs a regime of consciousness and practices in which creation, speech, breath, and gestures are calibrated upon a shared hold. Within the general architecture of the Année posœnnoïale, it corresponds to the scale where collective orientation becomes readable.</p><p>The manuscript associates collective rituals with each season: Air calls for chants and vocal circles, Feu for ordeals and ardent vigils, Eau for crossings and recompositions, Terre for plantings, constructions, and gestures of incarnation. The season thus becomes a respiratory organ of the collective, an axis of stabilization at broad amplitude, aligned with solar and lunar cycles.</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "expand",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      features: [
        "Seasonal unit: three months form a large collective breath.",
        "Four regimes: Air, Feu, Eau, and Terre structure the year at a broad scale.",
        "Attested calculation: Addition synchrêtique of the three months, then reduction into a seasonal signature.",
        "Developed function: stabilize a regime and make the months converge toward a common hold.",
        "Ritual orientation: each season calls for collective practices coherent with its archetype."
      ],
      questions: [
        "Which seasonal regime dominates here: Air, Feu, Eau, or Terre, and which axis of practice does it call for?",
        "Which minimal adjustment makes the season inhabitable: cadence, ritual, collective frame, density?",
        "Which brief act confirms the hold of the regime: chant, vigil, gesture, work, or planting?",
        "Does the reading belong to an isolated month, or to a wider collective breath?"
      ],
      example_box: "<div><strong>Ex.</strong> A community opening a cycle of shared chants, breathed gestures, and common orientations at the threshold of Air is living the logic of Saison posœnnoïale: hold ceases to be individual and becomes collective.</div>",
      family_1: "<p><strong>Internal links:</strong> Saison posœnnoïale is a sub-entry of AP. It connects with the Mois posœnnoïal that composes it, with Numéris for reading signatures, with the triad 3–6–9, with Humanus for rites and collectives, and with Souffle d’Or as the breathing unity.</p>",
      family_2: "<p><strong>Systemic function:</strong> within the architecture of the Année posœnnoïale, the season moves from the month’s archetypal regime toward a collective orientation aligned with solar and lunar cycles. It stabilizes a broad common breath and prepares the crossing toward the Épagomènes.</p>",
      word_blocks: [
        { head: "1) Saison", text: "Broad duration, regime, shared orientation: a hold that exceeds the instant and the month in order to become collective respiration." },
        { head: "2) Posœnnoïale", text: "The term places the season within the ecology of the corpus: breathed reading of time, synchretic calculation, aligned practices, and collective hold." },
        { head: "3) Whole", text: "Saison posœnnoïale names the unit of three months when they become a respiratory regime, a readable signature, and an axis of common practices." }
      ],
      word_notes: [
        "Two attested ideograms: conceptual and functional.",
        "Attested essential definition: 3 months = collective breath.",
        "Attested function: stabilize a regime.",
        "Canonical calculation example: Air = 5986 → 28 → 10 → 1."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    ES: {
      title: "Saison posœnnoïale",
      title_img: CONCEPT_URL,
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Gran respiración colectiva, firma estacional y orientación de las prácticas)",
      h_def: "Definición operativa",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Agrupación de tres meses: gran respiración de un régimen. Addition synchrêtique + firma: orientar prácticas y gestos hacia una tenida colectiva.",
      def_long: "<p>En <em>Katûpirsia&nbsp;9</em>, Saison posœnnoïale es una unidad del tiempo fundada en la agrupación de tres meses. Constituye una respiración colectiva, más amplia que el mes, y organiza el año en cuatro grandes regímenes: Air, Feu, Eau y Terre.</p><p>El corpus precisa que su cálculo se apoya en la Addition synchrêtique de los tres meses que la componen. Se suman sus totales sincréticos y luego se reducen según la lógica interna para obtener una firma estacional. El ejemplo dado para la estación de Air es explícito: enero + febrero + marzo = 5986 → 28 → 10 → 1.</p><p>Saison posœnnoïale no es, por tanto, una simple agrupación calendaria. Instala un régimen de conciencia y de prácticas donde la creación, la palabra, el aliento y los gestos se calibran sobre una tenida común. En la arquitectura general de la Année posœnnoïale, corresponde a la escala en la que la orientación colectiva se vuelve legible.</p><p>El manuscrito asocia rituales colectivos a cada estación: Air llama a cantos y círculos vocales, Feu a pruebas y vigilias ardientes, Eau a travesías y recomposiciones, Terre a plantaciones, construcciones y gestos de encarnación. La estación se convierte así en un órgano respiratorio de lo colectivo, un eje de estabilización a gran amplitud, acordado con los ciclos solares y lunares.</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "desplegar",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Unidad estacional: tres meses forman una gran respiración colectiva.",
        "Cuatro regímenes: Air, Feu, Eau y Terre estructuran el año a gran escala.",
        "Cálculo atestiguado: Addition synchrêtique de los tres meses y reducción en firma estacional.",
        "Función desarrollada: estabilizar un régimen y hacer converger los meses hacia una tenida común.",
        "Orientación ritual: cada estación llama a prácticas colectivas coherentes con su arquetipo."
      ],
      questions: [
        "¿Qué régimen estacional domina aquí: Air, Feu, Eau o Terre, y qué eje de práctica convoca?",
        "¿Qué ajuste mínimo vuelve habitable la estación: cadencia, ritual, marco colectivo, densidad?",
        "¿Qué acto breve confirma la tenida del régimen: canto, vigilia, gesto, obra o plantación?",
        "¿La lectura pertenece a un mes aislado o a una respiración colectiva más amplia?"
      ],
      example_box: "<div><strong>Ej.</strong> Una comunidad que abre un ciclo de cantos compartidos, gestos respirados y orientaciones comunes en el umbral de Air vive la lógica de Saison posœnnoïale: la tenida deja de ser individual y se vuelve colectiva.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> Saison posœnnoïale es una subentrada de AP. Se vincula con el Mois posœnnoïal que la compone, con Numéris para la lectura de las firmas, con la tríada 3–6–9, con Humanus para los ritos y colectivos, y con Souffle d’Or como unidad respirante.</p>",
      family_2: "<p><strong>Función sistémica:</strong> dentro de la arquitectura de la Année posœnnoïale, la estación hace pasar del régimen arquetípico del mes a una orientación colectiva acordada con los ciclos solares y lunares. Estabiliza una gran respiración común y prepara el cruce hacia los Épagomènes.</p>",
      word_blocks: [
        { head: "1) Saison", text: "Duración amplia, régimen, orientación común: una tenida que supera el instante y el mes para convertirse en respiración colectiva." },
        { head: "2) Posœnnoïale", text: "El término sitúa la estación en la ecología del corpus: lectura respirada del tiempo, cálculo sincrético, prácticas acordadas y tenida del colectivo." },
        { head: "3) Conjunto", text: "Saison posœnnoïale nombra la unidad de tres meses cuando se vuelven régimen respiratorio, firma legible y eje de prácticas comunes." }
      ],
      word_notes: [
        "Dos ideogramas atestiguados: conceptual y funcional.",
        "Definición esencial atestiguada: 3 meses = respiración colectiva.",
        "Función atestiguada: estabilizar un régimen.",
        "Ejemplo canónico de cálculo: Air = 5986 → 28 → 10 → 1."
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };
  function updateButtons(root, lang){
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      var active = normLang(btn.getAttribute('data-po-lang') || '') === lang;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener('click', function(){
        applyLangEverywhere(normLang(btn.getAttribute('data-po-lang') || 'FR'));
      });
    });
  }

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: '',
    lang: 'FR'
  };

  var AUDIO_UI = {
    FR: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    EN: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    ES: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR;
  }

  function ensureAudioStyles(){
    if (document.getElementById('po-saison-audio-styles-20260328')) return;
    var style = document.createElement('style');
    style.id = 'po-saison-audio-styles-20260328';
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap;margin:10px 0 12px;}',
      '.po-lex-summary .po-axis-audio-wrap{margin:0;justify-content:flex-end;}',
      '.po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(255,255,255,.78);color:inherit;border-radius:999px;padding:6px 10px;font:inherit;font-size:12px;line-height:1.1;cursor:pointer;}',
      '.po-axis-audio-btn.is-playing{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18);font-weight:700;}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role, detailIndex){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    if (detailIndex != null) btn.setAttribute('data-po-audio-index', String(detailIndex));
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetails = root.querySelector('.po-lex-details');
        if (meta && meta.parentNode === panel) meta.insertAdjacentElement('afterend', generalWrap);
        else if (defShort && defShort.parentNode === panel) defShort.insertAdjacentElement('beforebegin', generalWrap);
        else if (firstDetails && firstDetails.parentNode === panel) firstDetails.insertAdjacentElement('beforebegin', generalWrap);
        else panel.insertBefore(generalWrap, panel.firstChild);
      }
    }

    var details = root.querySelectorAll('.po-lex-details');
    Array.prototype.forEach.call(details, function(detail, idx){
      var summary = detail.querySelector('.po-lex-summary');
      if (!summary) return;
      var wrap = summary.querySelector('.po-axis-audio-wrap[data-po-audio-role="block"]');
      if (!wrap){
        wrap = document.createElement('span');
        wrap.className = 'po-axis-audio-wrap';
        wrap.setAttribute('data-po-audio-role', 'block');
        wrap.appendChild(createAudioButton('block', idx));
        summary.appendChild(wrap);
      }
    });

    refreshAudioButtons(root, lang);
    bindAudioEvents(root);
  }

  function refreshAudioButtons(root, lang){
    var ui = audioUI(lang);
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    Array.prototype.forEach.call(btns, function(btn){
      var role = btn.getAttribute('data-po-audio-role');
      var isActive = PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === getButtonKey(btn);
      btn.classList.toggle('is-playing', !!isActive);
      btn.textContent = isActive ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function refreshAudioButtonsEverywhere(){
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ refreshAudioButtons(root, getLang()); });
  }

  function bindAudioEvents(root){
    if (root.__po_audio_bound) return;
    root.__po_audio_bound = true;
    root.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('.po-axis-audio-btn') : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      var role = btn.getAttribute('data-po-audio-role');
      var key = getButtonKey(btn);
      if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
        stopAudio();
        return;
      }
      if (role === 'general') startAudio(root, 0, 'general');
      else startAudio(root, parseInt(btn.getAttribute('data-po-audio-index') || '0', 10), 'block');
    });
  }

  function getButtonKey(btn){
    if (!btn) return '';
    var role = btn.getAttribute('data-po-audio-role') || '';
    var idx = btn.getAttribute('data-po-audio-index') || '';
    return role + ':' + idx;
  }

  function cleanText(text){
    return clampStr(text).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function collectGeneralText(root){
    var parts = [];
    ['title', 'kicker', 'h_def', 'def_short', 'def_long'].forEach(function(slot){
      var el = root.querySelector('[data-po-slot="' + slot + '"]');
      if (el) parts.push(cleanText(el.textContent || ''));
    });
    return cleanText(parts.join('. '));
  }

  function collectBlockText(detail){
    if (!detail) return '';
    var parts = [];
    var summaryTitle = detail.querySelector('.po-lex-summary__title');
    if (summaryTitle) parts.push(cleanText(summaryTitle.textContent || ''));

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    Array.prototype.forEach.call(clone.querySelectorAll('.po-axis-audio-wrap,.po-axis-audio-btn'), function(n){
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    parts.push(cleanText(clone.textContent || ''));
    return cleanText(parts.join('. '));
  }

  function splitSpeechChunks(text){
    var src = cleanText(text);
    if (!src) return [];
    var sentences = src.match(/[^.!?;:]+[.!?;:]?|[^.!?;:]+$/g) || [src];
    var chunks = [];
    var acc = '';

    sentences.forEach(function(sentence){
      var s = cleanText(sentence);
      if (!s) return;
      if (!acc){
        acc = s;
        return;
      }
      if ((acc + ' ' + s).length <= 210) acc += ' ' + s;
      else {
        chunks.push(acc);
        acc = s;
      }
    });

    if (acc) chunks.push(acc);
    return chunks.length ? chunks : [src];
  }

  function getVoiceLang(lang){
    var L = normLang(lang);
    if (L === 'EN') return 'en-US';
    if (L === 'ES') return 'es-ES';
    return 'fr-FR';
  }

  function chooseVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var target = getVoiceLang(lang).toLowerCase();
    var base = target.split('-')[0];
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    for (var i = 0; i < voices.length; i++){
      if ((voices[i].lang || '').toLowerCase() === target) return voices[i];
    }
    for (var j = 0; j < voices.length; j++){
      if ((voices[j].lang || '').toLowerCase().indexOf(base) === 0) return voices[j];
    }
    return null;
  }

  function openDetailIfNeeded(unit){
    if (!unit || unit.type !== 'block' || !unit.detail) return;
    unit.detail.open = true;
  }

  function speakCurrentUnit(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.root) return;
    if (PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    openDetailIfNeeded(unit);
    var chunks = splitSpeechChunks(unit.text);
    if (!chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      speakCurrentUnit();
      return;
    }

    PO_AUDIO_STATE.chunks = chunks.slice();
    speakNextChunk();
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
        stopAudio();
        return;
      }
      speakCurrentUnit();
      return;
    }

    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks.shift());
    utter.lang = getVoiceLang(PO_AUDIO_STATE.lang);
    var voice = chooseVoice(PO_AUDIO_STATE.lang);
    if (voice) utter.voice = voice;
    utter.rate = 0.98;
    utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    PO_AUDIO_SYNTH.speak(utter);
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = '';
    refreshAudioButtonsEverywhere();
  }

  function startAudio(root, startIndex, mode){
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();

    var details = Array.prototype.slice.call(root.querySelectorAll('.po-lex-details'));
    var units = [];
    if (mode === 'general'){
      units.push({ type: 'general', text: collectGeneralText(root) });
      details.forEach(function(detail, idx){ units.push({ type: 'block', detail: detail, index: idx, text: collectBlockText(detail) }); });
      PO_AUDIO_STATE.activeKey = 'general:';
    } else {
      details.slice(startIndex).forEach(function(detail, offset){
        units.push({ type: 'block', detail: detail, index: startIndex + offset, text: collectBlockText(detail) });
      });
      PO_AUDIO_STATE.activeKey = 'block:' + String(startIndex);
    }

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.filter(function(u){ return cleanText(u.text); });
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.lang = getLang();

    refreshAudioButtonsEverywhere();
    speakCurrentUnit();
  }

  if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.onvoiceschanged !== 'undefined'){
    PO_AUDIO_SYNTH.onvoiceschanged = function(){};
  }

  function renderRoot(root, lang){
    var T = CONTENT[lang] || CONTENT.FR;
    setSlotText(root, 'title', T.title);
    setSlotHTML(root, 'kicker', T.kicker);
    setSlotImgSrc(root, 'title_img', T.title_img || T.chip_urls[0], T.title);
    setSlotText(root, 'h_def', T.h_def);
    setSlotText(root, 'chip_1', T.chips[0]);
    setSlotText(root, 'chip_2', T.chips[1]);
    setSlotImgSrc(root, 'chip_1_img', T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, 'chip_2_img', T.chip_urls[1], T.chips[1]);
    setSlotHTML(root, 'def_short', T.def_short);
    setSlotHTML(root, 'def_long', T.def_long);
    setSlotText(root, 'h_features', T.h_features);
    setSlotText(root, 'h_questions', T.h_questions);
    setSlotText(root, 'hint_fold', T.hint_fold);
    setSlotText(root, 'hint_fold2', T.hint_fold);
    setSlotText(root, 'h_family', T.h_family);
    setSlotText(root, 'hint_fold3', T.hint_fold);
    setSlotText(root, 'h_wordbuild', T.h_wordbuild);
    setSlotText(root, 'hint_fold4', T.hint_fold);
    renderListInto(root, 'features', T.features);
    renderListInto(root, 'questions', T.questions);
    setSlotHTML(root, 'example_box', T.example_box);
    setSlotHTML(root, 'family_1', T.family_1);
    setSlotHTML(root, 'family_2', T.family_2);
    renderWordBlocks(root, 'wordbuild_blocks', T.word_blocks);
    renderListInto(root, 'wordbuild_notes', T.word_notes);
    setSlotText(root, 'cta_translate', T.cta_translate);

    var cta = root.querySelector('.po-axis-breath-link');
    if (cta) cta.setAttribute('href', clampStr(cta.getAttribute('href') || PAGE_URL));

    protectDOM(root);
    updateButtons(root, lang);
    wireButtons(root);
    ensureAudioButtons(root, lang);
  }

  function applyLangEverywhere(lang3){
    var lang = storeLang(lang3);
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ renderRoot(root, lang); });
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());
    window.addEventListener('po:lexicon-ready', function(){ applyLangEverywhere(getLang()); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.PoKatupirsia9SaisonPosoennoialeTextsFR_EN_ES_20260328 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
